import { STORE_CLOSE_CLASS, STORE_CLOSE_TEXT, STORE_IS_OPEN_CLASS, STORE_IS_OPEN_TEXT, STORE_OPEN_SOON_CLASS, STORE_OPEN_SOON_TEXT } from "@/config/statusStore";
import { storeIsOpen } from "@/event/closeBus";
import { configOpeningHours } from "@/storage/setting/configOpeningHours";
import { configWebOrder } from "@/storage/setting/configWebOrder";
import type { HoursType } from "@/storage/stores";
import stores from "@/storage/stores";
import { getMinutesByData } from "@/utils/time/getMinutesByData";
import { ref } from "vue";

interface statusStoreIsEmpty {
    class: string
    text: string
}

export const statusStore = ref<statusStoreIsEmpty>({
    class: '',
    text: ''
})

let intervalId: number | undefined


export function getStatusStoreHappy() {
    const arrayPlanning = ref<HoursType[]>([])
    const store = stores.getStoresData()

    if (!store.name || !configOpeningHours.value) return

    arrayPlanning.value = configOpeningHours.value.opening_hours

    if (Number(configWebOrder.value) !== 0) {
        const today = new Date()
        const currentDay = today.getUTCDay()
        const currentHour = today.getHours()
        const currentMinutes = today.getMinutes()
        const currentTime = getMinutesByData(`${currentHour}:${currentMinutes}`)

        const sortedPlanning = [...arrayPlanning.value].sort((a, b) => {
            const [aHour] = a.open.split(':').map(Number)
            const [bHour] = b.open.split(':').map(Number)
            return aHour - bHour
        })

        const daysData = sortedPlanning.map((p) => p.days).flat()
        const uniqueDaysData = [...new Set(daysData.sort())]

        if (!uniqueDaysData.includes(currentDay.toString()) && sortedPlanning.length > 0) {
            storeIsOpen.value = false
            statusStore.value = {
                class: STORE_CLOSE_CLASS,
                text: STORE_CLOSE_TEXT
            }
            return
        } else {
            // const currentDayPlanning = sortedPlanning.find((sp) =>
            //     sp.days.includes(String(currentDay))
            // )
            // console.log(currentDayPlanning)


            let twoParts = false
            if (sortedPlanning.length > 1) {
                twoParts = sortedPlanning.some((sp) => sp.days.includes(String(currentDay)))
            }

            for (const sp of sortedPlanning) {
                const openTime = getMinutesByData(sp.open)
                const closeTime = getMinutesByData(sp.close)

                const currentTimeBeforeOpen = currentTime < openTime
                const currentTimeAfterOpen = currentTime >= openTime
                const currentTimeBeforeClose = currentTime <= closeTime
                const currentTimeAfterClose = currentTime > closeTime

                if (currentTimeAfterClose && !twoParts) {
                    storeIsOpen.value = false
                    statusStore.value = {
                        class: STORE_CLOSE_CLASS,
                        text: STORE_CLOSE_TEXT
                    }
                    break
                }

                if (currentTimeAfterOpen && currentTimeBeforeClose) {
                    storeIsOpen.value = true
                    statusStore.value = {
                        class: STORE_IS_OPEN_CLASS,
                        text: STORE_IS_OPEN_TEXT
                    }
                    const fifteenMinutesBeforClose = closeTime - 15
                    if (currentTime >= fifteenMinutesBeforClose && storeIsOpen.value) {
                        intervalId = window.setInterval(
                            () => {
                                getStatusStoreHappy()
                            },
                            5 * 60 * 1000
                        )
                    }
                    break

                }

                if (currentTimeBeforeClose || currentTimeBeforeOpen) {
                    storeIsOpen.value = true
                    statusStore.value = {
                        class: STORE_OPEN_SOON_CLASS,
                        text: STORE_OPEN_SOON_TEXT + sp.open
                    }
                    return
                }
            }
        }
    } else {
        storeIsOpen.value = false
        statusStore.value = {
            class: STORE_CLOSE_CLASS,
            text: STORE_CLOSE_TEXT
        }
    }
}